import { TeamSubscriptionDto } from "api/Api";
import clsx from "clsx";
import { hoursUntil } from "common/date";
import React from "react";
import { Link } from "react-router-dom";
import paths from "routes/paths";

import css from "./type.module.scss";

type Props = {
  endAt: string;
  subscription: TeamSubscriptionDto;
};

const SubscriptionTrialActive = ({ endAt, subscription }: Props) => {
  return (
    <div className={clsx(css.wrapper, css.blue)}>
      <div className={clsx(css.content, css.trial)}>
        <strong style={{ textDecoration: "none" }}>Trial active</strong>
        <span>
          {subscription.plan.description.split(" - ")[0]} plan starts{" "}
          {hoursUntil(endAt)}
        </span>
        <span>
          <Link
            className={css.link}
            style={{ textDecoration: "underline" }}
            to={paths.settingsBillingCancel()}
          >
            Cancel
          </Link>{" "}
          or{" "}
          <Link
            className={css.link}
            style={{ textDecoration: "underline" }}
            to={paths.settingsBillingTrialConvert()}
          >
            Convert now
          </Link>
        </span>
      </div>
    </div>
  );
};

export default SubscriptionTrialActive;
